/**
 * 창고 · 구역 (시안) — 창고 안의 자리(구역)와 그 구역에 모아 두는 카테고리. 가짜 데이터, 저장 안 됨 (2026-10-06).
 * 완성되면 설정 안의 탭으로 들어간다(ROADMAP A4). 지금은 시안 묶음에 따로.
 */

import { SolaView, htmlSolaWithInstance } from '@hm-spt/sola';
import { ROW_NO_HEAD, rowNoCell } from '../components/row-no';
import { escapeHtml } from '../lib/cells';
import { PREVIEW } from '../data/preview-inventory';

export class ZonesPreviewView extends SolaView<Record<string, never>> {
  constructor() {
    super();
    this.data = {};
  }

  override getTitle(): string {
    return '창고 · 구역 (시안) — HCLTech';
  }

  render(): HTMLElement {
    const rows = PREVIEW.ZONES.map((zone, index) => `<tr>${rowNoCell(0, index)}<td>${escapeHtml(zone.warehouse)}</td><td class="mono">${zone.zone === null ? '<span class="text-muted">—</span>' : escapeHtml(zone.zone)}</td><td>${zone.category === null ? '<span class="text-muted">아무거나</span>' : escapeHtml(zone.category)}</td><td class="text-muted">${escapeHtml(zone.note)}</td><td><button type="button" class="btn-ghost">고치기</button></td></tr>`).join('');
    return htmlSolaWithInstance(this)`
      <div class="page pv-page">
        <header class="page-header"><h1>🏷️ 창고 · 구역 <small class="pv-tag">시안</small></h1></header>
        <div class="pv-banner">시안 — 가짜 데이터 · 저장 안 됨. 완성되면 설정 안의 탭으로</div>
        <section class="page-body pv-body">
          <p class="pv-lead">창고 안의 자리(구역)와 그 구역에 모아 두는 카테고리. 입고 · 검수 때 실물의 구역 기본값이 여기서 온다. 실물의 창고 값은 실제 자리만 — "불용창고 · 분실창고" 는 창고가 아니라 실물의 상태다.</p>
          <table class="pv-table pv-table-sm"><thead><tr>${ROW_NO_HEAD}<th>창고</th><th>구역</th><th>기본 카테고리</th><th>메모</th><th></th></tr></thead><tbody>${rows}</tbody></table>
          <div><button type="button" class="btn-ghost">구역 추가</button></div>
        </section>
      </div>`;
  }
}
